
import moment from 'moment';

export function mascaraDataDDMMAAAA(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 8);                       //Remove tudo além dos 8 dígitos
    v = v.replace(/(\d{2})(\d)/, "$1/$2");      //Coloca uma barra entre dia e mês
    v = v.replace(/(\d{2})(\d)/, "$1/$2");      //Coloca um ponto entre mês e ano
    return v
}

export function mascaraDataMMAAAA(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 6);                       //Remove tudo além dos 6 dígitos
    v = v.replace(/(\d{2})(\d)/, "$1/$2");      //Coloca um ponto entre mês e ano
    return v
}

export function mascaraCEP(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 8);                       //Remove tudo além dos 8 dígitos
    v = v.replace(/(\d{5})(\d)/, "$1-$2");      //Coloca uma barra entre dia e mês
    return v
}

export function mascaraTelefones(v) {
    if (v === undefined) {
        return ""
    }
    let qtd = v.length;
    v = v.replace(/\D/g, "");
    v = v.substring(0, 11);
    v = v.replace(/(\d{2})(\d)/, "($1)$2");
    if (qtd < 13) {
        v = v.replace(/(\d{4})(\d)/, "$1-$2");
    } else {
        v = v.replace(/(\d{5})(\d)/, "$1-$2");
    }
    return v
}

export function mascaraValorEmReal(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 8);                       //Remove tudo além dos 8 dígitos
    //Coloca uma virgula entre centavos e reais
    let tam = v.length
    if (tam > 5) {
        v = v.replace(/(\d)(\d{5})$/, "$1.$2");      //Coloca um ponto entre centena e milhar
        if (v.substring(0, 1) === "0") v = v.replace(/0/, "");
    }
    if (tam > 2) {
        v = v.replace(/(\d)(\d{2})$/, "$1,$2");           //Remove tudo o que não é dígito
        if (v.substring(0, 2) === "00") v = v.replace(/00/, "0");
        if (v.length === 5 && v.substring(0, 1) === "0") v = v.replace(/0/, "");
    } else if (tam === 2) {
        v = "0," + v
    } else {
        v = "0,0" + v
    }
    return v
}

export function mascaraValorEmDolar(v) {
    if (v === undefined) {
        return ""
    }
    v = v.replace(/\D/g, "");                   //Remove tudo o que não é dígito
    v = v.substring(0, 8);                       //Remove tudo além dos 8 dígitos
    //Coloca uma virgula entre centavos e reais
    let tam = v.length
    if (tam > 5) {
        v = v.replace(/(\d)(\d{5})$/, "$1.$2");      //Coloca um ponto entre centena e milhar
        if (v.substring(0, 1) === "0") v = v.replace(/0/, "");
    }
    if (tam > 2) {
        v = v.replace(/(\d)(\d{2})$/, "$1,$2");           //Remove tudo o que não é dígito
        if (v.substring(0, 2) === "00") v = v.replace(/00/, "0");
        if (v.length === 5 && v.substring(0, 1) === "0") v = v.replace(/0/, "");
    } else if (tam === 2) {
        v = "0," + v
    } else {
        v = "0,0" + v
    }
    return v
}

export function converterStringValorEmFloat(v) {
    //console.log("funcao")
    //console.log(v)
    if (v === undefined) {
        return ""
    }
    //A função considera que o campo de texto que vai receber estará no padrão XXX.XXX,XX 
    let tam = v.length
    if (tam > 2) {
        v = v.replace(".", "");                      //Remove tudo o que é ponto
        v = v.replace(",", "");
        v = v.replace(/(\d)(\d{2})$/, "$1.$2");
    } else if (tam === 2) {
        v = `0.${v}`
    } else {
        v = `0.0${v}`
    }
    //console.log(v)
    return v
}


export function isValidStringDate(d) {
    let numbers = d.replace(/\D/g, "");
    if (numbers.length !== 8) {
        return false;
    }
    return true;
}

export function formatarStringQuantidade(v) {
    if (v === undefined) {
        return ""
    }
    return String(v).replace(new RegExp("[^0-9|.|,]*", 'g'), "").replace(new RegExp(",", 'g'), ".");
}

export function compareDatas(data1, data2) {
    if (data1 === undefined || data2 === undefined) {
        return false;
    }
    if ((data1 > data2) ||
        (data1.getDate() === moment().toDate().getDate() &&
            data1.getMonth() === moment().toDate().getMonth() &&
            data1.getFullYear() === moment().toDate().getFullYear())) {
        return true;
    }
    return false;
}

export function compareDatasAntigas(data1, data2) {
    if (data1 === undefined || data2 === undefined) {
        return false;
    }
    if ((data1 > data2) ||
        (data2.getDate() === moment().toDate().getDate() &&
            data2.getMonth() === moment().toDate().getMonth() &&
            data2.getFullYear() === moment().toDate().getFullYear())) {
        return true;
    }
    return false;
}

export function mascaraCNPJ(v) {
    if (v === undefined) {
        return "";
    }
    v = v.replace(/\D/g, "")                           //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/, "$1.$2")             //Coloca ponto entre o segundo e o terceiro dígitos
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3") //Coloca ponto entre o quinto e o sexto dígitos
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")           //Coloca uma barra entre o oitavo e o nono dígitos
    v = v.replace(/(\d{4})(\d)/, "$1-$2")              //Coloca um hífen depois do bloco de quatro dígitos
    return v
}

export function mascaraCPF(v) {
    if (v === undefined) {
        return "";
    }
    v = v.replace(/\D/g, "")                    //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, "$1.$2")       //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2") //Coloca um hífen entre o terceiro e o quarto dígitos
    return v
}

export function validaCpf(strCPF) {
    if (strCPF === undefined) {
        return false;
    }
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === "00000000000" ||
        strCPF === "11111111111" ||
        strCPF === "22222222222" ||
        strCPF === "33333333333" ||
        strCPF === "44444444444" ||
        strCPF === "55555555555" ||
        strCPF === "66666666666" ||
        strCPF === "77777777777" ||
        strCPF === "88888888888" ||
        strCPF === "99999999999") {
        return false;
    }

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
}

export function validaCnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj === '') return false;

    if (cnpj.length !== 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999") {
        return false;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado.toString() !== digitos.charAt(0).toString())
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado.toString() !== digitos.charAt(1).toString())
        return false;

    return true;
}

export function validaEMAIL(email) {
    const regex = new RegExp("\\w+@\\w+\\.\\w+", "g")
    if (regex.test(email)) {
        return true;
    } else {
        return false;
    }
}

export function validaInsEstadual(texto) {
    const regex = new RegExp("\\d+|\\.|-|/|^isento$", "gi")
    if (regex.test(texto)) {
        return true;
    } else {
        return false;
    }
}

export function b64toBlob(b64Data, contentType, sliceSize) {

    var byteCharacters = Buffer.from(b64Data, 'base64').toString("binary");
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });

    return blob;

}


export const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});